export class InventoryClassModel {
  inventoryClassId: number = 0;
  code: number = 0;
  name: string = '';
}
